import moment from 'moment'
import React, { useRef, useState } from 'react'
import { checkTranslation, getObject } from '../utils/useful'
import tableComponents from './tableComponents'
import FixedView from './FixedView'


class GridViewer extends React.Component {



    checkFilter(filter, source) {
        // console.log(filter)
        let result = null
        let currentOperator = "or"
        if (filter && Array.isArray(filter))
            if (filter.length == 1) {
                let operationResult = this.checkFilterCondition(filter[0], source)
                result = this.doOperation(result, currentOperator, operationResult)
            } else {
                filter.forEach(filterItem => {
                    if (Array.isArray(filterItem)) {
                        let operationResult = this.checkFilter([filterItem], source)
                        // console.log("HERE")
                        // console.log(this.checkFilter([filterItem],source))
                        result = this.doOperation(result, currentOperator, operationResult)
                    } else {
                        currentOperator = filterItem
                    }
                });
            }


        return result
    }

    doOperation(result, operation, operationResult) {
        // console.log(result)
        // console.log(operationResult)
        if (result == null) {
            return operationResult
        } else {
            switch (operation) {
                case ("or"):
                    return result || operationResult
                case ('and'):
                    return result && operationResult
            }
        }
    }

    checkFilterCondition(item, source) {

        let first = this.makeConditionValue(item[0], source)
        let condition = item[1]
        let second = this.makeConditionValue(item[2])

        switch (condition) {
            case ("=="):
                return first == second
            case ('>'):
                return first > second
            case ('<'):
                return first < second
            case ('<='):
                return first <= second
            case ('>='):
                return first >= second
        }
    }

    makeConditionValue(value, source) {
        let result = value
        if (typeof value == 'object' && !Array.isArray(value)) {
            if (value.key) {
                result = this.getObjectValue(value.key, source)
            }
            if (value.action && value.action == "date") {
                result = moment(new Date()).tz('Asia/Singapore').add(value.offset ? value.offset : 0, value.range ? value.range : 'days').valueOf()
                // console.log(result)
            }
        }
        // console.log(result)
        return result
    }



    getObjectValue(key, source) {
        if (source) {
            if (key.includes('.')) {
                return this.getObjectValue(key.split('.')[1], source[key.split('.')[0]])
            } else {
                return source[key]
            }
        } else {
            return null
        }
    }




    render() {
        let indicator = (this.props.page?.indicators && this.checkFilter(this.props.page?.indicators?.filter, this.props.data))
        // let borderColor = "#f9f9f9"
        // if (this.props.paymentTable && last) {

        //     if (moment(prop.dueDate).startOf('day').valueOf() != moment(last.dueDate).tz('Asia/Singapore').startOf('day').valueOf()) {
        //         borderColor = '#ccddee'
        //     }
        // }

        return (

            <div className="w-100 flexc row m-0">
               

                    {this.props.headers?.map((header, index) => {
                        if (header.showMain != false) {

                            let isSticky = false
                            if (index === 0 && Math.abs(this.props.scrollX) > 5) {
                                isSticky = true
                            }
                            let data = getObject(this.props.data, header.key)
                            let Component = tableComponents[header.type]

                            return (
                                <div className="col-6 col-lg-4 col-xl-2 pb-2 px-0 px-lg-1" style={{minHeight:'100px'}}>
                                    {/* <div className="h-100 px-3 py-3" style={{ backgroundColor: remainColor === 0 ? '#FEF4DF' : '#fff', borderRadius: '16px' }}> */}
                                    <div className="h-100 px-3 py-2" style={{ backgroundColor: '#FEF4DF', borderRadius: '16px',minHeight:'100px' }}>
                                        <div className="flexc flex-wrap">

                                            <div key={header.key} style={{ transition: 'all 0.3' }}>
                                                {Component && (
                                                    <Component data={data} fullValues={this.props.data} header={header} />
                                                )}
                                            </div>
                                        </div>
                                        <p className=" pt-1" style={{ color: '#232F45',fontSize:12,fontWeight:600 }}>{checkTranslation(header.information?.label)}</p>
                                        <p className=" pt-1 pb-2" style={{ color: '#232F45',fontSize:11,fontWeight:400, opacity: 0.7 }}>{checkTranslation(header.information?.desc)}</p>

                                    </div>
                                </div>

                            )
                        }
                    })}





                
            </div>


        )
    }

}

export default GridViewer
